var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('mobile-top-bar'),_c('main',{staticClass:"main-layout__content"},[_c('router-view')],1),_c('bottom-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }